import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import PropTypes from 'prop-types';
// Models
import { attributes } from 'models/entity';
import { sortedEntities } from 'models/installation';
// Custom
import { entityDataShape } from 'constants/PropTypesShapes';
import ResourcesSelectField from 'components/inputFields/ResourcesSelectField';
import EntityIcon from './EntityIcon';

const EntitiesSelectField = ({
  entities, value, errorText, onChange,
}) => (
  <ResourcesSelectField
    labelId="field.entity"
    value={value}
    errorText={errorText}
    resources={
      _map(entities, (entity) => ({
        ...entity,
        itemCustomIcon: <EntityIcon entity={entity} />,
      }))
    }
    displayKey={
      (entity) => {
        const { isMaster, hostsOneparkBookings, name } = attributes(entity);
        return (
          <LocalizedMessage
            id="info.installationEntityName"
            values={{ isMaster, hostsOneparkBookings, name }}
          />
        );
      }
    }
    onChange={onChange}
  />
);

EntitiesSelectField.propTypes = {
  entities: PropTypes.arrayOf(entityDataShape).isRequired,
  value: PropTypes.number,
  errorText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

EntitiesSelectField.defaultProps = {
  value: null,
  errorText: null,
};

const mapStateToProps = (state) => ({
  entities: sortedEntities(state.installation.current.data),
});

module.exports = connect(
  mapStateToProps,
)(EntitiesSelectField);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/entities/EntitiesSelectField.js